import { render, staticRenderFns } from "./chinesePush.vue?vue&type=template&id=2f490e2b&scoped=true"
import script from "./chinesePush.vue?vue&type=script&lang=js"
export * from "./chinesePush.vue?vue&type=script&lang=js"
import style0 from "./chinesePush.vue?vue&type=style&index=0&id=2f490e2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f490e2b",
  null
  
)

export default component.exports